<script lang="ts" setup>
const props = defineProps({
  documentId: {
    type: String,
    required: false,
  },
});

const emits = defineEmits(["reportProblem"]);

const description = ref("");
const isControl = ref(false);
const error = ref<string | undefined>();

const isReporting = ref(false);
const reportProblem = async () => {
  error.value = undefined;

  if (description.value == "") {
    error.value = "Please enter a description.";
    return;
  }

  isReporting.value = true;

  emits(
    "reportProblem",
    description.value,
    isControl.value,
    selectedTokens.value
  );

  description.value = "";
};

const onChangeControl = () => {
  if (isControl.value == true) {
    description.value = "This is a control test.";
  }
};

const selectedTokens = ref<ParagraphTokens>([]);

onMounted(() => {
  const documentId = props.documentId;

  if (documentId == undefined) return;

  const documentSelectionStore = useDocumentSelectionStore(documentId);
  selectedTokens.value = documentSelectionStore.selectedTokens;
});
</script>

<template>
  <div class="flex flex-col p-2">
    <h2 class="text-h5">Flag for Review</h2>
    <TransitionsCollapsible>
      <span v-if="error" class="mt-2 text-danger-default text-body-1">
        {{ error }}
      </span>
    </TransitionsCollapsible>
    <BaseTextArea class="my-2 h-[100px] w-[400px]" v-model="description" />
    <BaseFormComponent class="my-2">
      <template #label> Is control test? </template>
      <BaseToggle v-model="isControl" @update:model-value="onChangeControl" />
    </BaseFormComponent>
    <div v-if="selectedTokens.length > 0" class="mt-2">
      <h2 class="text-h5">Selected Text</h2>
      <div class="flex flex-row gap-[2px] p-2 w-[600px] flex-wrap">
        <span v-for="token in selectedTokens" :key="token.id">
          {{ token.text }}
        </span>
      </div>
    </div>
    <BaseButton @click="reportProblem" class="w-[100px]"> Report </BaseButton>
  </div>
</template>

<style scoped></style>
